export const errorMessageExtensions = {
  empty: item => `No ${item} to be removed`,
  update: item => `Failed to update ${item}`,
  create: item => `Failed to create ${item}`,
  send: item => `Unable to send ${item}`,
  delete: item => `Unable to delete ${item}`,
  remove: item => `Unable to remove ${item}`,
  save: item => `Unable to save ${item}`,
  add: item => `Unable to add ${item}`,
  upload: () => 'Upload Failed',
  uploadFile: item => `Unable to upload "${item} file"`,
  connect: item => `Unable to connect ${item}`,
  disconnect: item => `Unable to disconnect ${item}`,
  uploadQueue: item => `Failed to add ${item} to queue`,
  track: item => `Unable to track ${item}`,
  untrack: item => `Unable to untrack ${item}`,
  notifySeller: () => 'Unable to send message to seller',
  notifyBuyer: () => 'Unable to send message to Buyer',
  download: () => 'Unable to download file',
  updateListings: () => 'Unable to update diamonds.',
  email: () => 'Unable to send email.',
  getDictionary: () => 'Cannot get Jewelry import dictionary',
  load: item => `Unable to load ${item}`,
  edit: item => `Unable to edit ${item}`,
  duplicates: items => `Unable to upload images with the same names: ${items.join(', ')}`,
  submitForm: () => 'Form submission failed',
  markReadUnread: (item, unread) => `${item} unable to mark as ${unread ? 'unread' : 'read'}`,
  ringStyleSetting: () => 'Failed to update Ring Style Collection',
  copyDiamondFeed: () => 'II feed is not available',
  published: item => `Failed to published ${item}`,
  unpublished: item => `Failed to unpublished ${item}`,
  print: item => `Unable to print ${item}`
};

export const successMessageExtensions = {
  update: item => `${item} updated successfully`,
  create: item => `${item} created successfully`,
  send: item => `${item} sent successfully`,
  delete: item => `${item} deleted successfully`,
  remove: item => `${item} removed successfully`,
  save: item => `${item} saved successfully`,
  add: item => `${item} added successfully`,
  upload: item => `${item} successfully uploaded`,
  updatePendingChanges: item =>
    `${item} updated successfully and waiting for customer service approval`,
  connect: item => `${item} connected successfully`,
  disconnect: item => `${item} disconnected successfully`,
  uploadQueue: item => `${item} added to queue successfully`,
  track: item => `Now tracking ${item}`,
  untrack: item => `${item} now untracked`,
  notifySeller: () => 'Message sent to seller',
  notifyBuyer: () => 'Message sent to buyer',
  compareDiamonds: item => `${item} added to compare successfully`,
  download: () => 'Download Started',
  updateListings: () => 'All diamonds updated. Listings will expire in 8 days.',
  email: () => 'Email sent',
  uploadMediaFiles: () => 'Your media files have been successfully uploaded',
  csvDone: () => 'Your csv files have been successfully uploaded',
  multipleUploadDone: () => 'Multiple upload done',
  submitForm: () => 'Form submitted successfully',
  copy: item => `${item} copy successfully`,
  markReadUnread: (item, unread) => `${item} mark as ${unread ? 'unread' : 'read'} successfully`,
  ringStyleSetting: () => 'Ring Style Collection Updated',
  published: item => `${item} published`,
  unpublished: item => `${item} unpublished`,
  print: item => `Print ${item} successfully`
};

export const toastTypes = {
  success: 'success',
  error: 'error',
  message: 'message'
};
